import(/* webpackMode: "eager" */ "D:\\b\\baczonedz\\src\\app\\tools\\flashcards\\page.tsx");
